import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ValidateVinService {
  constructor(private translate: TranslateService) {
    translate.use('ar-team');
  }
  validateVin(vin): ValidateVinResponse {
    if (vin?.length !== 17) {
      return { message: this.translate.instant('vin_validation.char_length_error'), valid: false };
    }

    const alphaNumericRegex = /^[0-9a-zA-Z]+$/;
    const isAlphaNumericString = vin.match(alphaNumericRegex);

    if (!isAlphaNumericString) {
      return { message: this.translate.instant('vin_validation.alphanumeric_error'), valid: false };
    }

    const isSequencialVinNumber = this.isSequencial(vin);

    if (isSequencialVinNumber) {
      return { message: this.translate.instant('vin_validation.serial_char_error'), valid: false };
    }
    const isRepeated = this.checkRepeatedStringMoreThanFifth(vin);

    if (isRepeated) {
      return { message: this.translate.instant('vin_validation.repeated_char_error'), valid: false };
    }

    return { message: 'valid', valid: true };
  }

  private isSequencial(input) {
    if (!input) {
      return;
    }
    const numpattern = '0123456789012345789';
    const charpattern = 'ABCDEFGHIJKLMNOPQRSTUVWXYZYXWVUTSRQPONMLKJIHGFEDCBA';
    const numberOfSequentialChar = 5;
    for (let i = 0; i < input.length - 1; i++) {
      const shard = input.substring(i, i + numberOfSequentialChar);
      if (shard?.length === numberOfSequentialChar && numpattern.indexOf(shard) !== -1) {
        return true;
      }
      if (shard?.length === numberOfSequentialChar && charpattern.indexOf(shard.toUpperCase()) !== -1) {
        return true;
      }
    }
    return false;
  }

  private checkRepeatedStringMoreThanFifth(str) {
    str = str.replace(/\s+/g, '_');
    return /(\S)(\1{4,})/g.test(str);
  }
}

export interface ValidateVinResponse {
  message: string;
  valid: boolean;
}

export function vinValidator(service: ValidateVinService): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (!service.validateVin(control.value).valid) {
      return { vinNumberValid: true };
    }
    return null;
  };
}